import React, { Component } from 'react';
import {MainLayout} from 'components/layouts';
import {Link, withRouter} from 'react-router-dom';
import EmailInvite from 'components/fair/fair-email/EmailInvite.jsx';

export default class EmailInvitePage extends Component {
  render() {
    return (
      <MainLayout>
        <div>
          <div className='mb15'>
            <Link className='btn-back' to={`/fair/${this.props.match.params.id}`}><i className='fa fa-chevron-left' />Quay về trang chi tiết </Link>
          </div>
          <div className='wrap-heading'>
            <h1>Quản lý email mời doanh nghiệp tham gia hội chợ</h1>
          </div>
          <EmailInvite params={this.props.match.params} />
        </div>
      </MainLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./pages/fair/fair-emails/EmailInvitePage.jsx